import React, { useState, useEffect } from 'react';
import {Text, TouchableOpacity, View, StyleSheet, Dimensions} from 'react-native';
import styles from '../../style/scanpack';
import {LinearGradient} from 'expo-linear-gradient';
import {Camera} from 'expo-camera';
import i18n from 'i18n-js';
import AsyncStorage from '@react-native-async-storage/async-storage';

const CameraPermissionPrompt = (props) => {
  const [windowWidth, setWindowWidth] = useState(Dimensions.get('window').width);

  useEffect(()=>{
    const dimensionsHandler = Dimensions.addEventListener('change', ({ window }) => {
      setWindowWidth(window.width);
    });
    return () => {
      dimensionsHandler.remove();
    };
  },[])

  const handleRetry = async () => {
    const {status} = await Camera.requestCameraPermissionsAsync();
    if (status === 'granted') {
      props.redirect();
    }
  };

  const handleDisable = async () => {
    await AsyncStorage.setItem('packingCamEnabled', 'false');
    props.redirect();
  };

  const getContainerWidth = () => {
    if (windowWidth <= 900) {
      return '100%';
    } else if (windowWidth > 900 && windowWidth < 1200) {
      return '60%';
    } else {
      return '50%';
    }
  };

  return (
    <View testID="CameraPermissionPrompt" style={[styles.responseView]}>
      <View
        style={[
          windowWidth >= 900 ? styles.typeScanContainer : '',
          windowWidth <= 900 ? styles.recordSerialMobile : '',
          styling.mainViewContainer
        ]}>
        <LinearGradient
          locations={[0, 1]}
          start={{x: 0, y: 1}}
          end={{x: 0, y: 0}}
          colors={['#d47d02', '#ffb636']}
          style={[
            styles.typeScanBox, 
            styling.gradientContainer,
            { width: getContainerWidth() }
          ]}>
          <View style={styling.cancelIcon}>
            <TouchableOpacity
              dataSet={{componentName: 'CommonCloseModalBtn'}}
              testID="CancelIcon"
              onPress={props.redirect}>
              <i className="icon-cancel" style={styling.cancelIconStyle}></i>
            </TouchableOpacity>
          </View>

          <View style={styling.messageContainer}>
            <Text
              testID="MainMessage"
              style={[
                styles.scanCountText,
                styling.messageText,
                windowWidth >= 900 ? styling.largeText : styling.smallText
              ]}>
              {i18n.t("order.cameraPermissionMessage")}
            </Text>
          </View>

          <View
            style={[
              styling.buttonContainer,
              windowWidth <= 900 ? styling.columnDirection : styling.rowDirection
            ]}>
            <Button
              onPress={handleRetry}
              testId={'RetryButton'}
              message={i18n.t("order.retryButton")}
            />
            <Button
              onPress={handleDisable}
              testId={'DisableButton'}
              message={i18n.t("order.disableButton")}
            />
          </View>
        </LinearGradient>
      </View>
    </View>
  );
};

const Button = ({onPress, message, testId}) => {
  return (
    <TouchableOpacity
      testID={testId}
      style={[styles.modalButton, styling.button]}
      onPress={onPress}>
      <LinearGradient
        style={styling.buttonGradient}
        colors={['#ffb636', '#d47d02']}
        start={{x: 0, y: 0}}
        end={{x: 0, y: 1}}>
        <Text testID={`${testId}-label`} style={styling.buttonText}>{message}</Text>
      </LinearGradient>
    </TouchableOpacity>
  );
};

const styling = StyleSheet.create({
  mainViewContainer: {
    marginBottom: '9%'
  },
  gradientContainer: {
    backgroundColor: '#d3dfea',
    paddingHorizontal: 20,
    paddingVertical: 15,
    width: '50%',
    marginTop: '2%',
    borderColor: '#e8971a',
    borderWidth: 3,
    height: 'fit-content',
    boxShadow: '2px 2px 10px #363636'
  },
  messageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15
  },
  messageText: {
    fontFamily: 'Poppins_300Light',
    textAlign: 'justify',
    width: '100%',
    marginBottom: 10
  },
  largeText: {
    fontSize: 20
  },
  smallText: {
    fontSize: 16
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: 20
  },
  rowDirection: {
    flexDirection: 'row'
  },
  columnDirection: {
    flexDirection: 'column'
  },
  button: {
    width: 'auto',
    padding: 12,
    borderRadius: 25,
    backgroundColor: '#ffffff',
    marginBottom: 10,
    padding: 0
  },
  buttonGradient: {
    borderRadius: 15,
    borderWidth: 1,
    borderColor: 'black'
  },
  buttonText: {
    textAlign: 'center',
    color: '#000000',
    fontSize: 16,
    paddingHorizontal: 10,
    paddingVertical: 5,
    fontFamily: 'Poppins_300Light'
  },
  cancelIcon: {
    display: 'flex',
    alignSelf: 'flex-end',
    marginBottom: 10
  },
  cancelIconStyle: {
    fontSize: '26px',
    color: '#4b4132'
  }
});

export default CameraPermissionPrompt;
